// extracted by mini-css-extract-plugin
export default {"getUtilisateurFailure":"ConfirmationPage_getUtilisateurFailure__jAq9K","titleParagraph":"ConfirmationPage_titleParagraph__ZArdB"};